export default {
    announcements: 'Announcements',
    announcementsHelper: 'Roughly 1-2 emails a month.',
    description: 'User Notifications - {{userEmail}}',
    onboarding: 'Onboarding, Tips, Tricks',
    onboardingHelper:
        'We occasionally send you a few emails to help you get the most out of MakeLeaps.',
    save: 'Save',
    systemNotifications: 'System Notifications',
    systemNotificationsHelper:
        'Important notifications such as password resets.',
    title: 'Notification Settings',
};
